import { useCallback, MouseEvent } from 'react';
import { trackEvent } from '../utils/googleAnalytics';
import { reportAppinesDeeplinkConversion } from '../utils/googleAds';
import { supabase } from '../lib/supabaseClient';

interface UseAppinesDeeplinkConversionReturn {
  handleClick: (e: MouseEvent<HTMLAnchorElement>) => void;
}

export const useAppinesDeeplinkConversion = (
  deeplinkUrl: string
): UseAppinesDeeplinkConversionReturn => {
  const handleClick = useCallback(
    (_e: MouseEvent<HTMLAnchorElement>) => {
      const sourcePage = window.location.pathname;

      trackEvent('appines_deeplink_clicked', 'conversion', sourcePage);

      supabase
        .from('deeplink_clicks')
        .insert({
          target_url: deeplinkUrl,
          source_page: sourcePage,
          referrer: document.referrer || '',
          user_agent: navigator.userAgent || '',
        })
        .then(() => undefined, () => undefined);

      reportAppinesDeeplinkConversion();
    },
    [deeplinkUrl]
  );

  return { handleClick };
};
